// extracted by mini-css-extract-plugin
export var container = "_5m-0";
export var disabled = "_5m-4";
export var fullWidth = "_5m-3";
export var lined = "_5m-1";
export var selected = "_5m-5";
export var tab = "_5m-2";